/**
 * The existing route links for the Consumer flow - Quick Quote.
 */
export enum QuickQuoteRouteEnum {
  /**
   * The Quick Quote route.
   */
  QUICK_QUOTE = 'quick-quote'
}
